import {OnInit, Component, NgModule, ViewChild, NgZone, ElementRef} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterModule, Router} from '@angular/router';
import {BrowserModule, DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {ReCaptchaModule} from "angular2-recaptcha"
import {Util} from "util/Util";
import { PasswordRecoveryHttp } from '../../../tsScripts/providers/http/PasswordRecoveryHttp';
import { PRODUCT_TS, URL_PRODUCT, DEFAULT_SUBDOMAIN_TS } from '../MainComponent';
import { ErrorDTO } from '../../../tsScripts/DTO/ErrorDTO';
import { LoadingButtonModule } from '../../../tsScripts/directives/LoadingButton';
import { FloatingLabelModule } from '../../../tsScripts/directives/FloatingLabel';
import { TokenStorage } from 'providers/TokenStorage';

declare let DEFAULT_SUBDOMAIN: string;
declare let userInterface:any;

@Component({
    selector: 'change-password',
    templateUrl: "../../../views/components/passwordRecovery/changePassword.html",
    providers: [PasswordRecoveryHttp],
    styleUrls: ["../../../styles/password-recovery.css"]
})
export class ChangePassword implements OnInit {

    PRODUCT: any;
    loading: boolean;
    alertMessage: string;
    typeAlert: string;
    firstPassword: string;
    secondPassword: string;
    validatingToken: boolean;
    token: string;
    
    userInterface:any=userInterface;

    constructor(private zone: NgZone,
        private PasswordRecoveryHttp: PasswordRecoveryHttp,
        private sanitizer: DomSanitizer,
        private router: Router,
        private tokenStorage: TokenStorage) {
        this.loading = false;
        this.alertMessage = "";
        this.firstPassword = "";
        this.secondPassword = "";
        this.validatingToken = true;
        this.PRODUCT = PRODUCT_TS;
    }

    private changePassword() {
        this.alertMessage = "";
        this.typeAlert = "";
        this.zone.run(() => {
            this.loading = true;
            let param: any = {
                token: this.token.toString(),
                password: this.firstPassword.toString()
            }
            this.PasswordRecoveryHttp.changePassword(param).subscribe((response: any) => {
                this.loading = false;
                this.router.navigate(['/password/recovery/successfulKeyChange'], {queryParams: null});
            }, (error: ErrorDTO) => {
                this.alertMessage = error.errorMessage;
                this.typeAlert = "error";
                this.loading = false;
            });
        });
    }

    validatePasswords() {
        if (this.firstPassword !== this.secondPassword) {
            this.alertMessage = "Las contraseñas no coinciden";
            this.typeAlert = "error";
        } else if (this.firstPassword.length > 100 && this.secondPassword.length > 100) {
            this.alertMessage = "La contraseña debe ser menor a 100 caracteres";
            this.typeAlert = "warning";
        } else {
            this.changePassword()
        }
    }

    private validateToken() {
        this.zone.run(() => {
            let param: any = {
                token: this.token
            }
            this.PasswordRecoveryHttp.validateToken(param).subscribe((response: any) => {
                this.validatingToken = false;
            }, (error: ErrorDTO) => {
                this.validatingToken = false;
                this.router.navigate(['/password/recovery/invalidRequest'], {queryParams: null});
            });
        });
    }
    
    goToLogin(){
        let linkToGo = (URL_PRODUCT != '') ? URL_PRODUCT : this.PRODUCT.URL_LOGIN;
        window.location.href = linkToGo;
    }

    ngOnInit() {
        this.tokenStorage.verifyCookieAndLocalStorage();
        let token = Util.getParameterByName('token');
        if (token != '') {
            this.token = token;
            this.validateToken();
        } else {
            this.router.navigate(['/login'], {queryParams: null});
        }
    }
}

@NgModule({
    declarations: [ChangePassword],
    imports: [FormsModule, BrowserModule, LoadingButtonModule, RouterModule, FloatingLabelModule, ReCaptchaModule],
    providers: [],
    entryComponents: [],
    exports: []
})
export class ChangePasswordModule {
}